import { render } from "./RecycleBin.vue?vue&type=template&id=29cf51fc"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/RecycleBin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29cf51fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29cf51fc', __exports__)) {
    api.reload('29cf51fc', __exports__)
  }
  
  module.hot.accept("./RecycleBin.vue?vue&type=template&id=29cf51fc", () => {
    api.rerender('29cf51fc', render)
  })

}


export default __exports__